var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { eventDeepMerge } from "../helpers";
import { observable, action, makeObservable } from "mobx";
import { DataCondition, } from "../../../contracts";
import { disposer } from "@draftkings/sportsbook-common-utils";
import { computedFn } from "mobx-utils";
export class ScoreboardsRetriever {
    constructor(options) {
        this.updateEventGroup = (scoreboardData) => {
            const event = this.scoreboardData.get(scoreboardData.eventId);
            if (event) {
                eventDeepMerge(event, scoreboardData);
            }
            else {
                this.scoreboardData.set(scoreboardData.eventId, scoreboardData);
            }
        };
        // During the PO phase of CMS, it was identified that the Scoreboard functionality within PrePacks will not operate as expected,
        // because the CMS widget is not responsible for serving data related to scoreboards, such as SBW.
        this.getPrePacksEventScoreboardData = computedFn((eventId) => this.eventPerEventId.get(eventId));
        this.subscribe = (leagueId) => {
            if (this.SportsbookLeague) {
                const league = new this.SportsbookLeague({
                    entity: "events",
                    query: `$filter=leagueId eq '${leagueId}'`,
                    includeMarkets: "none",
                }, "event", false, this.onDataCallback, this.onErrorCallback);
                return () => {
                    league.deactivate();
                };
            }
            return disposer;
        };
        this.onDataCallback = (response) => {
            this.add(response.data.add);
            this.change(response.data.change);
            this.remove(response.data.remove);
        };
        this.add = (payload) => {
            payload.events.forEach((event) => {
                var _a;
                if ((_a = event.eventScorecard) === null || _a === void 0 ? void 0 : _a.scorecardComponentId) {
                    event.eventScorecard = Object.assign(Object.assign({}, event.eventScorecard), { 
                        // There is a problem in BE, they return scoreCards on an event update and this will be fixed with the new API version
                        // TODO: Use scorecards instead of scoreCards when the BE fix it
                        scorecards: event.eventScorecard.scoreCards });
                    this.eventPerEventId.set(event.id, event);
                }
            });
        };
        this.change = (payload) => {
            payload.events.forEach((newEvent) => {
                var _a;
                const existEvent = this.eventPerEventId.get(newEvent.id);
                if (existEvent) {
                    eventDeepMerge(existEvent, Object.assign(Object.assign({}, newEvent), { eventScorecard: Object.assign(Object.assign({}, newEvent.eventScorecard), { 
                            // There is a problem in BE, they return scoreCards on an event update and this will be fixed with the new API version
                            // TODO: Use scorecards instead of scoreCards when the BE fix it
                            scorecards: (_a = newEvent.eventScorecard) === null || _a === void 0 ? void 0 : _a.scoreCards }) }));
                    this.eventPerEventId.set(newEvent.id, existEvent);
                }
            });
        };
        this.remove = (payload) => {
            payload.events.forEach((event) => {
                const existingEvent = this.eventPerEventId.get(event);
                if (existingEvent) {
                    existingEvent.status = "FINISHED";
                }
            });
        };
        this.onErrorCallback = (err) => {
            this.error = {
                leagueId: "",
                statusCode: "WebSocketConnectionError",
                message: err.message,
            };
        };
        this.scoreboardData = observable.map();
        this.eventPerEventId = observable.map();
        this.leagueNavRequestResolver = options.leagueNavRequestResolver;
        this.error = undefined;
        this.subscriptionDisposer = disposer;
        this.SportsbookLeague = options.SportsbookLeague;
        this.condition = options.condition;
        makeObservable(this, {
            error: observable,
            updateEventGroup: action,
            onErrorCallback: action,
        });
    }
    activate() {
        /* do nothing */
    }
    deactivate() {
        this.subscriptionDisposer();
        this.scoreboardData.clear();
        this.eventPerEventId.clear();
        this.error = undefined;
    }
    updateData(scoreboardData) {
        scoreboardData.forEach(this.updateEventGroup);
    }
    loadEventsData(leagueId) {
        this.sendRequest(leagueId)
            .then(() => {
            if (this.eventPerEventId.size === 0) {
                this.setCondition("EMPTY");
            }
            else {
                this.setCondition("LOADED");
                this.subscriptionDisposer = this.subscribe(leagueId);
            }
        })
            .catch((err) => {
            this.setCondition("ERROR");
            this.error = {
                leagueId,
                statusCode: "FetchingEventsPerLeagueError",
                message: err instanceof Error ? err.message : JSON.stringify(err),
            };
        });
    }
    sendRequest(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.leagueNavRequestResolver.cancel();
            const data = yield this.leagueNavRequestResolver.send({
                leagueId,
            });
            if (data) {
                this.processEventsBff(data);
                this.setCondition("LOADED");
            }
            else {
                this.setCondition("ERROR");
                throw new Error(`Events data missing for leagueId: ${leagueId}`);
            }
        });
    }
    processEventsBff(data) {
        data.events.forEach((x) => {
            this.eventPerEventId.set(x.id, x);
        });
    }
    setCondition(value) {
        this.condition.set(ScoreboardsRetriever.ConditionKey, DataCondition[value]);
    }
}
ScoreboardsRetriever.ConditionKey = "PrePacksScoreboards";
//# sourceMappingURL=ScoreboardsRetriever.js.map